// extracted by mini-css-extract-plugin
export default {"div_flex":"assessmentdetails_div_flex__oizpd","detail_div":"assessmentdetails_detail_div__FZqsS","span_div":"assessmentdetails_span_div__iHvQU"};